
import TYPES from './types'
import { ServerStatisticsState } from './state';

export const fetchServerStatisticsStart = () => ({
    type: TYPES.FETCH_START
});

export const fetchServerStatisticsSuccess = (data: ServerStatisticsState) => ({
    type: TYPES.FETCH_SUCCESS,
    payload: data.servers
});
